import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SubscriptionsSdkSharedModule } from '@gelato-api-ui/sdk/src/lib/shared/subscriptions-shared/subscriptions-sdk-shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { LokaliseModule } from '@gelato-api-ui/sdk/src/lib/shared/lokalise/lokalise.module';
import { SubscriptionsFacade } from './+state/subscriptions.facade';
import { ChargeBeeService } from './services/charge-bee.service';

@NgModule({
  providers: [ChargeBeeService, SubscriptionsFacade],
  imports: [CommonModule, TranslateModule, SubscriptionsSdkSharedModule, LokaliseModule],
})
export class SubscriptionsSharedModule {}
